export const MONITOR_PRODUCT = 'monitor'; // eslint-disable-line import/prefer-default-export
